import { throwForFailedResponse } from "@/lib/errors/error-handler";

async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(path, { method: "GET", credentials: "include" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data?.success === false) {
    throwForFailedResponse(res, data, "Request failed");
  }
  return (data?.data ?? data) as T;
}

async function postJson(path: string, body: unknown) {
  const res = await fetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    credentials: "include",
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throwForFailedResponse(res, data, "Failed to complete request");
  }
  return data;
}

export const languageService = {
  async getLanguage(): Promise<any> {
    return getJson<any>("/api/language");
  },

  async update(payload: string) {
    return postJson("/api/language", payload);
  },
};
